import {
  SUBMIT_DOC,
  SUBMIT_DOC_SUCCESS,
  SUBMIT_DOC_FAILED,
  SUBMIT_REFIDOC,
  SUBMIT_REFIDOC_SUCCESS,
  SUBMIT_REFIDOC_FAILED,
  FEES_ERROR,
  DOWNLOAD_ALL,
  DOWNLOAD_ALL_SUCCESS,
  DOWNLOAD_ALL_FAILED,
} from './types';

export const submitDoc = (data) => ({
  type: SUBMIT_DOC,
  payload: data,
});

export const submitDocSuccess = (data) => ({
  type: SUBMIT_DOC_SUCCESS,
  payload: data,
});

export const submitDocFailed = (error) => ({
  type: SUBMIT_DOC_FAILED,
  payload: error,
});

export const submitRefiDocs = (data) => ({
  type: SUBMIT_REFIDOC,
  payload: data,
});

export const submitRefiDocsSuccess = (data) => ({
  type: SUBMIT_REFIDOC_SUCCESS,
  payload: data,
});

export const submitRefiDocsFailed = (error) => ({
  type: SUBMIT_REFIDOC_FAILED,
  payload: error,
});

export const feesError = (error) => ({
  type: FEES_ERROR,
  payload: error,
})

export const downloadAll = (data) => ({
  type: DOWNLOAD_ALL,
  payload: data,
})

export const downloadAllSuccess = () => ({
  type: DOWNLOAD_ALL_SUCCESS,
})

export const downloadAllFailed = () => ({
  type: DOWNLOAD_ALL_FAILED,
})
